import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import BetaGateModal from './BetaGateModal';
import { hasValidBetaAccess, isBetaGateEnabled } from '../api/api';

export default function SiteBetaGate({ children }) {
  const location = useLocation();
  const gateEnabled = isBetaGateEnabled();
  const isAuthCallback = location.pathname === '/auth/callback';
  const [unlocked, setUnlocked] = useState(() => !gateEnabled || hasValidBetaAccess());

  if (isAuthCallback) {
    return children;
  }

  if (!gateEnabled) {
    return children;
  }

  if (!unlocked) {
    return (
      <BetaGateModal
        open
        siteGate
        onApproved={() => setUnlocked(true)}
      />
    );
  }

  return children;
}
